import React from 'react';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue
} from './ui/select';
import { useCategories } from '../context/CategoryContext';

const ALL_VALUE = '__all__';

const CategorySelect = ({ value, onChange, includeAll, className, ...props }) => {
  const { categories, categoriesWithAll } = useCategories();
  const options = includeAll ? categoriesWithAll : categories;

  // Convert empty string (used by filter) to sentinel for Radix
  const selectValue = (includeAll && (value === '' || value === undefined)) ? ALL_VALUE : (value || '');

  const handleChange = (newValue) => {
    if (onChange) {
      // Convert sentinel back to empty string for the filter
      const actual = newValue === ALL_VALUE ? '' : newValue;
      onChange({ target: { value: actual } });
    }
  };

  // Check if the current value exists in options
  const valueExists = options.some(cat => (cat.value || ALL_VALUE) === selectValue);

  return (
    <Select 
      value={valueExists ? selectValue : undefined} 
      onValueChange={handleChange}
      key={selectValue}
    >
      <SelectTrigger
        className={className || "w-full px-4 py-3 border border-beige rounded-lg focus:border-sage focus:ring-2 focus:ring-sage/20 bg-white text-charcoal text-sm"}
        style={{ fontSize: '16px', minHeight: '48px' }}
        data-testid={props['data-testid']}
      >
        <SelectValue placeholder="Select category" />
      </SelectTrigger>
      <SelectContent>
        {options.map(cat => (
          <SelectItem
            key={cat.value || ALL_VALUE}
            value={cat.value || ALL_VALUE}
          >
            {cat.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default CategorySelect;
